import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './BottomNav.css';

const BottomNav: React.FC = () => {
    const location = useLocation();

    // Helper to check if route is active
    const isActive = (path: string) => {
        return location.pathname === path ? 'active' : '';
    };

    return (
        <div className="bottom-nav d-lg-none">
            <Link to="/dashboard" className={`nav-item ${isActive('/dashboard')}`}>
                <i className="fa-solid fa-house"></i>
                <span>Home</span>
            </Link>

            <Link to="/pos" className={`nav-item ${isActive('/pos')}`}>
                <i className="fa-solid fa-cash-register"></i>
                <div className="center-fab">
                    <i className="fa-solid fa-plus"></i>
                </div>
                <span>Sale</span>
            </Link>

            <Link to="/account" className={`nav-item ${isActive('/account')}`}>
                <i className="fa-solid fa-user"></i>
                <span>Profile</span>
            </Link>
        </div>
    );
};

export default BottomNav;
